// ShareButton — botão universal que abre o ShareModal.
// Adiciona-se POR COMPOSIÇÃO nas telas (sem editar a lógica interna delas).
// Ícone Share2 dourado, discreto.
//
// Fase C.1 — automaticamente injeta o tema semanal ativo da landing
// (useDaily().weekly_theme) em todo share gerado, para que o card visual
// e o auto-select de template respeitem a direção editorial vigente.

import React, { useState } from "react";
import { Share2 } from "lucide-react";
import ShareModal from "./ShareModal";
import { useAuth } from "../../lib/authContext";
import useDaily from "../../lib/useDaily";

/**
 * Props (contentProps):
 *   contentType: "devocional"|"sermon"|"plan"|"verse"|"prayer"|"study"
 *   contentId: string
 *   title, mainText, verse, verseRef, application, question, prayer, theme, reflection
 */
export default function ShareButton({ variant = "icon", label = "Compartilhar", ...contentProps }) {
  const [open, setOpen] = useState(false);
  const { user } = useAuth?.() || { user: null };
  const { daily } = useDaily?.() || { daily: null };

  // Fase C.1 — anexa tema semanal ativo (silencioso se null).
  const wt = daily?.weekly_theme || null;
  const enrichedProps = wt
    ? {
        ...contentProps,
        weekly_theme_slug: wt.theme_slug || null,
        weekly_theme_name: wt.theme_name || null,
        weekly_theme_accent: wt.accent_color || null,
      }
    : contentProps;

  const trigger = variant === "icon" ? (
    <button
      type="button"
      onClick={() => setOpen(true)}
      aria-label="Compartilhar esta reflexão"
      data-testid="share-button"
      className="inline-flex items-center justify-center w-10 h-10 rounded-full text-gold hover:bg-gold/10 transition-colors"
    >
      <Share2 className="w-5 h-5" />
    </button>
  ) : (
    <button
      type="button"
      onClick={() => setOpen(true)}
      data-testid="share-button"
      className="inline-flex items-center gap-2 rounded-full border border-gold/50 text-gold px-4 py-2 text-[11px] uppercase tracking-widest hover:bg-gold/10 transition-colors"
    >
      <Share2 className="w-3.5 h-3.5" />
      {label}
    </button>
  );

  return (
    <>
      {trigger}
      <ShareModal
        open={open}
        onClose={() => setOpen(false)}
        contentProps={enrichedProps}
        currentUser={user || null}
      />
    </>
  );
}
